"use client";
import{useSearchParams as t}from"next/navigation";import{useAnalyticsContext as n}from"../client/context/index.js";function e(){var e;const o=t(),{pageAlias:i}=n();return null!==(e=o.get("session-start-screen"))&&void 0!==e?e:i}export{e as default};
